import {browserHistory} from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/automaticresponses';

const AutomaticResponseService = {

  deleteAutomaticResponse( id ) {
    return axios
      .delete( `${baseEndpoint}/${id}` )
  },

  getAutomaticResponses( params ) {
    return axios
      .get( baseEndpoint, { params } )
  },

  getAutomaticResponse( id ) {
    return axios
      .get( `${baseEndpoint}/${id}` )
  },

  saveAutomaticResponse( data ) {
    return axios
      .post( baseEndpoint, data )
  },

  updateAutomaticResponse( id, data ) {
    return axios
      .put( `${baseEndpoint}/${id}`, data )
  },
};

export default AutomaticResponseService;



// WEBPACK FOOTER //
// ./services/AutomaticResponseService.js